/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Location_jsonld } from './Location_jsonld';
import type { RoomStay_jsonld } from './RoomStay_jsonld';
export type UrlDetails_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    PageType: UrlDetails_jsonld.PageType;
    RoomStay?: RoomStay_jsonld | null;
    HotelId?: number | null;
    PoiId?: number | null;
    CountryId?: number | null;
    Predicates?: any[] | null;
    Location?: Location_jsonld | null;
    OrderBy?: UrlDetails_jsonld.OrderBy;
    OrderDirection?: UrlDetails_jsonld.OrderDirection;
};
export namespace UrlDetails_jsonld {
    export enum PageType {
        LIST = 'list',
        HOTEL = 'hotel',
        POI_LIST = 'poiList',
        POI = 'poi',
        CUSTOM = 'custom',
        CHECKOUT = 'checkout',
    }
    export enum OrderBy {
        CHEAPEST_RATE = 'CheapestRate',
        CHEAPEST_PER_PERSON_PER_NIGHT_RATE = 'CheapestPerPersonPerNightRate',
        DISCOUNT_PERCENT = 'DiscountPercent',
        SCORE = 'Score',
        RATINGS_AVERAGE = 'RatingsAverage',
        TYPE = 'Type',
        RANKING_ORDER = 'RankingOrder',
        RATING = 'Rating',
        DISTANCE = 'Distance',
    }
    export enum OrderDirection {
        ASCENDING = 'Ascending',
        DESCENDING = 'Descending',
    }
}
